// ----------------------
// <auto-generated>
// Generated using the script apiGenerator.js
// </auto-generated>
// -----------------------
import { configuration } from 'config/constants';
import {
    ApplicationsClient,
    BookmarksClient,
    HighlightLayoutsClient,
    InfoServicesClient,
    LearnMoresClient,
    LogsClient,
    MyAccountsClient,
    ServicesClient,
    SignaturesClient,
    UserDisclaimersClient,
    UsersClient,
    WidgetsClient,
} from './ServiceBoardApiClient';
import { http } from 'services/ApiService/Http';

const { baseApiUrls: { serviceBoard: baseApiUrl } } = configuration;

export const ApplicationsApi = new ApplicationsClient(baseApiUrl, http);
export const BookmarksApi = new BookmarksClient(baseApiUrl, http);
export const HighlightLayoutsApi = new HighlightLayoutsClient(baseApiUrl, http);
export const InfoServicesApi = new InfoServicesClient(baseApiUrl, http);
export const LearnMoresApi = new LearnMoresClient(baseApiUrl, http);
export const LogsApi = new LogsClient(baseApiUrl, http);
export const MyAccountsApi = new MyAccountsClient(baseApiUrl, http);
export const ServicesApi = new ServicesClient(baseApiUrl, http);
export const SignaturesApi = new SignaturesClient(baseApiUrl, http);
export const UserDisclaimersApi = new UserDisclaimersClient(baseApiUrl, http);
export const UsersApi = new UsersClient(baseApiUrl, http);
export const WidgetsApi = new WidgetsClient(baseApiUrl, http);
